import {
    DataTrackDeviceActivity,
    IDataDeviceActivity,
    IDeviceActivity,
    StatusDeviceActivity
} from "@containers/device/containers/deviceActivity/types";
import {parseJson} from "@helpers/convert/convert";


const parseDeviceInfo = (str: string): {
    displayName: string,
    groupNames: string[],
    deviceId: number,
    licensePlate: string,
    lastEventTimeTimestamp: number,
    appVersion: string | null,
} => {
    const info: {
        displayName: string,
        deviceId: number,
        licensePlate: string,
        lastEventTimeTimestamp: number,
        groupNames: string,
        appVersion: string | null,
    } = parseJson(str)

    return {
        groupNames: info?.groupNames?.split(',')?.map((it) => it.trim()),
        displayName: info?.displayName,
        deviceId: info?.deviceId,
        licensePlate: info?.licensePlate,
        lastEventTimeTimestamp: info?.lastEventTimeTimestamp,
        appVersion: info.appVersion || null
    }
}

export const transformTrackDeviceActivity = (data: DataTrackDeviceActivity): IDataDeviceActivity => {
    const devices: IDeviceActivity[] = []
    const mapGroupsNames: Record<string, string> = {}
    let globalHasAppVersion = false;

    const parseInfo = ({
                           displayName,
                           groupNames,
                           deviceId,
                           licensePlate,
                           lastEventTimeTimestamp,
                           appVersion,
                       }: {
        displayName: string,
        groupNames: string[],
        deviceId: number,
        licensePlate: string,
        lastEventTimeTimestamp: number,
        appVersion: string | null,
    }, status: StatusDeviceActivity) => {
        if (groupNames?.length) {
            groupNames.forEach((groupName) => {
                if (groupName in mapGroupsNames) {
                    return
                }
                mapGroupsNames[groupName] = groupName
            })
        }
        if (!globalHasAppVersion && appVersion && appVersion !== 'null') {
            globalHasAppVersion = true
        }
        devices.push({
            displayName,
            id: displayName,
            status: status,
            groupNames,
            deviceId,
            licensePlate,
            lastEventTimeTimestamp,
            appVersion
        })
    }

    if (data?.idOnline?.length) {
        data.idOnline.forEach((device) => {
            const info = parseDeviceInfo(device)
            parseInfo(info, 'online')
        })
    }
    if (data?.id1Hour?.length) {
        data.id1Hour.forEach((device) => {
            const info = parseDeviceInfo(device)
            parseInfo(info, 'oneHour')
        })
    }
    if (data?.idLastDay?.length) {
        data.idLastDay.forEach((device) => {
            const info = parseDeviceInfo(device)
            parseInfo(info, 'lastDay')
        })
    }
    if (data?.idLastWeek?.length) {
        data.idLastWeek.forEach((device) => {
            const info = parseDeviceInfo(device)
            parseInfo(info, 'lastWeek')
        })
    }
    if (data?.idLastMonth?.length) {
        data.idLastMonth.forEach((device) => {
            const info = parseDeviceInfo(device)
            parseInfo(info, 'lastMonth')
        })
    }
    if (data?.idBeforeLastMonth?.length) {
        data.idBeforeLastMonth.forEach((device) => {
            const info = parseDeviceInfo(device)
            parseInfo(info, 'beforeLastMonth')
        })
    }
    if (data?.idNotConnected?.length) {
        data.idNotConnected.forEach((device) => {
            const info = parseDeviceInfo(device)
            parseInfo(info, 'notConnected')
        })
    }

    if (data?.idInactive?.length) {
        data.idInactive.forEach((device) => {
            const info = parseDeviceInfo(device)
            parseInfo(info, 'inactive')
        })
    }

    return {
        total: {
            totalOneHour: data?.device1Hour ?? 0,
            totalBeforeLastMonth: data?.deviceBeforeLastMonth ?? 0,
            totalInactive: data?.deviceInactive ?? 0,
            totalLastDay: data?.deviceLastDay ?? 0,
            totalLastMonth: data?.deviceLastMonth ?? 0,
            totalLastWeek: data?.deviceLastWeek ?? 0,
            totalNotConnected: data?.deviceNotConnected ?? 0,
            totalOnline: data?.deviceOnline ?? 0,
        },
        devices,
        groups: Object.values(mapGroupsNames),
        hasAppVersion: globalHasAppVersion

    }
}